
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-areas/protective-orders",
      function () {
        return require("private-next-pages/practice-areas/protective-orders/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-areas/protective-orders"])
      });
    }
  